Namespace.create("cv.Views.Setup").PageView = Marionette.LayoutView.extend({
  template: cv.Templates["setup/page/view"],

  events: {
    "keyup #stub": "updateStub",
  },

  behaviors: [
    {
      behaviorClass: cv.FormBehavior,
      suppress_notifications: true,
    },
  ],

  validation: {
    display_name: [],
    stub: [
      {
        required: "true",
        msg: "Invalid URL",
      },
      {
        valid_project_stub: cv.api_path + "/projects/valid_stub",
      },
    ],
    funds_needed: [
      {
        required: "true",
        msg: " ",
      },
      {
        min: 0,
        msg: "Invalid amount",
      },
    ],
    end_date: [],
    project_updated: [],
    flex_metric_goal: [],
  },

  templateHelpers: function () {
    return {
      url: cv.campaign.get("url"),
      currency_code: cv.campaign.get("currency_code"),
      enable_project_end_date: cv.campaign.get("enable_project_end_date") == 1 ? true : false,
      enable_flex_metric: cv.campaign.get("enable_flex_metric") == 1 ? true : false,
      flex_metric_description: cv.campaign.get("flex_metric_description"),
      recommended_amount:
        cv.campaign.get("recommended_amount") > 0 ? cv.campaign.get("recommended_amount") : false,
      form_datepicker: cv.Templates["global/form/form_datepicker"]({
        label: "End Date",
        id: "end_date",
        default_date: cv.campaign.get("end_date"),
        timezone: "UTC",
        static: false,
        help_text: "Specify the end date in UTC.",
      }),
    };
  },

  initialize: function (options) {
    this.options = _.extend(this.options, options);

    this.listenTo(
      this,
      "form:saved",
      function () {
        vent.trigger("setup:next_screen");
      },
      this,
    );

    // This sync is fired when the page changes from the previous screen
    this.listenToOnce(
      this.model,
      "sync",
      function () {
        console.log("Setting default values...");
        this.defaultValues();
      },
      this,
    );

    console.log("SetupPageView initialized.");
  },

  updateStub: function () {
    this.$(".url-preview").text(this.$("#stub").val());
  },

  onAttach: function () {
    $("html, body").animate(
      {
        scrollTop: 0,
      },
      100,
    );

    // Change document title
    document.title = "Setup | Set Up Your Fundraising Page";
  },

  onShow: function () {
    this.defaultValues();
  },

  defaultValues: function () {
    // Setup display name
    if (this.model.get("display_name") == "") {
      this.$("#display_name").val(
        cv.project.get("user.first_name") + " " + cv.project.get("user.last_name"),
      );
    }

    // Setup default slug
    if (this.model.get("stub") == "") {
      this.$("#stub")
        .val(
          cv.convertToSlug(
            cv.project.get("user.first_name") + " " + cv.project.get("user.last_name"),
          ),
        )
        .trigger("change");
    }
    console.log("input val after", this.$("#stub").val());
    this.updateStub();

    // Setup default amount
    if (this.model.get("funds_needed") == 0) {
      this.$("#funds_needed").val(cv.campaign.get("recommended_amount"));
    }

    // Set the project as updated
    this.trigger("form:set", "project_updated", moment().utc().format("YYYY-MM-DD HH:mm:ss"));

    // Set the project as active
    this.trigger("form:set", "status", "active");
  },
});
